import React, { useRef } from 'react';
import classNames from 'classnames';
import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  Webform,
  WebformSelect,
} from '../../../components';

import { createEnhancedConversionEvent } from '../../../helpers/gtm';

import './style.scss';

const ParagraphWebform = ({ id, entity }) => {
  const webformValues = useRef({});
  const webformId = entity.getIn(['field_webform', 0, 'target_id']);
  const wrapped = entity.getIn(['field_wrapped', 0, 'value'], false);

  const pushEventOnSubmit = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'form_submitted',
      formId: webformId,
    });

    // Handle Google Enhanced conversion.
    const enhancedConversionEvent = createEnhancedConversionEvent(webformValues.current);
    // Fire the event if our required email field is present.
    if (enhancedConversionEvent.emailadres) {
      window.dataLayer.push(enhancedConversionEvent);
    }
  };

  const innerClasses = classNames('ParagraphWebform__inner', {
    'col-12': !wrapped,
    'col-12 col-lg-8 offset-lg-2 wrapped': wrapped,
  });

  return (
    <Container id={id} small className="ParagraphWebform">
      <div className="row">
        <div className={innerClasses}>
          <Webform
            root
            id={webformId}
            onSubmit={(values) => webformValues.current = values}
            onSuccessfullSubmit={pushEventOnSubmit}
            overriddenComponents={{ select: WebformSelect }}
          />
        </div>
      </div>
    </Container>
  );
};

export default ParagraphWebform;
